/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const WarehouseDispatchRequestModeEnum = {
    Ship: 'SHIP',
    Hold: 'HOLD',
    NotComing: 'NOT_COMING'
};
/**
 * Check if a given object implements the WarehouseDispatchRequest interface.
 */
export function instanceOfWarehouseDispatchRequest(value) {
    if (!('mode' in value) || value['mode'] === undefined)
        return false;
    return true;
}
export function WarehouseDispatchRequestFromJSON(json) {
    return WarehouseDispatchRequestFromJSONTyped(json, false);
}
export function WarehouseDispatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mode': json['mode'],
    };
}
export function WarehouseDispatchRequestToJSON(json) {
    return WarehouseDispatchRequestToJSONTyped(json, false);
}
export function WarehouseDispatchRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mode': value['mode'],
    };
}
